<!-- 机票航程  仓位列表 订单填写弹出层  订单详情 改签退票详情 展示  -->
<template>
  <div>
    <van-cell
      v-for="(info,index2) in flight"
      :key="index2"
      class="round-sm"
    >
      <van-row
        type="flex"
        align="center"
        class="title"
      >
        <van-col span="20">
          <slot name="tag" />
          <van-tag
            round
            size="medium"
            class="tag-green"
          >
            <span
              class="font10"
              v-show="index2==0&&flights.length>1||(flights.length==1&&travelType==2&&roundTrip==0)"
            >第1程</span>
            <span
              class="font10"
              v-show="index2==0&&flights.length==1&&travelType!=2"
            >第{{ xc }}程</span>
            <span
              class="font10"
              v-show="index2==1||(flights.length==1&&travelType==2&&roundTrip==1)"
            >第2程</span>
          </van-tag>&nbsp;
          {{ info.departDate || info.nDepartDate || info.oDepartDate }} {{ info.departDate|week }}
          <span v-show="info.flyTimeStr"><van-icon name="clock-o" />  时长{{ info.flyTimeStr || info.nFlyTime }}</span>
        </van-col>
        <van-col
          span="4"
          class="text-right"
        >
          <van-checkbox
            class="fr"
            v-model="info.checked"
            v-show="showCheck"
            @change="$emit('selected',index2,info.checked)"
          />
        </van-col>
      </van-row>

      <!--  -->
      <div>
        <van-row
          type="flex"
          align="center"
          v-if="showCabin&&info.cabin&&info.cabin.cabinName"
          class="row"
        >
          <van-col span="12">
            {{ info.cabin.cabinName }} <span class="red"><span class="font10">&yen;</span> {{
              info.price.salePrice
            }}</span>
          </van-col>
          <van-col
            span="12"
          />
        </van-row>
        <div class="relative">
          <van-row
            type="flex"
            align="center"
            class="row font16"
          >
            <van-col span="4">
              {{ info.departTime || (info.nDepartTime | time) || info.oDepartTime }}
            </van-col>
            <van-col span="2">
              <van-icon
                name="circle"
                class="line-top"
              />
              <span class="line" />
              <van-icon
                name="circle"
                class="line-bottom"
              />
            </van-col>
            <van-col span="16">
              {{ info.departCityName }}
              {{ info.departAirportName|airportName }}{{
                info.nDepartAirportName|airportName
              }}{{ info.oDepartCityName|airportName }} {{ info.departTerminal }}
            </van-col>
            <van-col
              span="2"
              v-show="showClear"
              class="text-right"
              @click="$emit('delet',index2)"
            >
              <van-icon
                class="main-color "
                name="clear"
              />
            </van-col>
          </van-row>

          <van-row v-show="info.stopNum>0">
            <van-col span="5" />
            <van-col span="19">
              <div class="stopList font12 gray bg-gray">
                <!--                <span class="stop main-color">停</span>&nbsp; 经停：-->
                <!--                <span-->
                <!--                  v-for="(ct ,index) in info.stopOverList"-->
                <!--                  :key="index"-->
                <!--                > {{ ct.cityName }} {{ ct.airportName }}  <br>-->
                <!--                  {{ $t('ddsj','到达时间') }}：{{ ct.arriveTime }}  {{ $t('C124','起飞时间') }}：{{ ct.departTime }}-->
                <!--                </span>-->
                <span v-if="info.flightType == 1">
                  <span class="stop main-color">停</span>&nbsp;经停：
                </span>
                <span v-else-if="info.flightType == 2">
                  <span
                    class="stop main-color"
                    @click="showPopup"
                  >通</span>&nbsp;通程：</span>
                <span
                  v-for="(ct, index) in info.stopOverList"
                  :key="index"
                > {{ ct.cityName }} {{ ct.airportName }} <br>
                  <span v-if="ct.arriveTime == '' ? false : true">{{ $t('ddsj', '到达时间') }}：{{
                    ct.arriveTime
                  }} {{ $t('C124', '起飞时间') }}：{{ ct.departTime }}</span>
                </span>
              </div>
              <van-popup
                v-model="show"
                position="bottom"
                round
                closeable
                close-icon-position="top-left"
                :style="{ height: '57%' }"
              >
                <div class="tc">
                  <p class="nr">
                    通程说明
                  </p>
                  <p class="ts">
                    ·温馨提示
                  </p>
                  <p
                    style="color: #0066ff;font-size: 11.5px;white-space: normal;width: 403px;letter-spacing: 3px;white-space: normal;width: 389px;margin: 10px 0px 0px 12px;"
                  >
                    {{ tc }}
                  </p>
                </div>
              </van-popup>
            </van-col>
          </van-row>
          <van-row
            type="flex"
            align="center"
            class="row font16"
          >
            <van-col span="4">
              {{ info.arriveTime || (info.nArriveTime | time) || info.oArriveTime }}
            </van-col>
            <van-col span="2" />
            <van-col span="18">
              {{ info.arriveCityName }}
              {{ info.arriveAirportName|airportName }}{{
                info.nArriveAirportName|airportName
              }}{{ info.oArriveCityName|airportName }} {{ info.arriveTerminal }}
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="title gray">
        <img
          :src="info.airlineImg"
          v-show="info.airlineImg"
          class="airIcon"
        >

        <span v-show="info.airlineName">{{ info.airlineName }} |</span>
        {{ info.flightNo || info.nFlightNo || info.oFlightNo }}
        <span v-if="info.cabinName">| {{ info.cabinName }}</span>
        <span v-else-if="info.cabin">| {{ info.cabin.cabinName || info.cabin.cabin }}</span>
        <span v-show="info.saleDiscount">| {{ info.saleDiscount|discount }}|</span>
        <span v-if="info.planeMap">| {{ info.planeMap[info.plane].planeName }}({{
          info.planeMap[info.plane].planeBody
        }})</span>
        <span v-else>{{ info.planeName }}</span>
        <span
          class="food"
          v-if="info.hasfood == 1 || info.hasFood == 1"
        >|有餐食</span>
        <span
          class="food"
          v-else
        >|无餐食
        </span>
        <span
          class="main-color"
          v-show="info.sharFlightNo"
          @click="$dialog.alert({message:'实际乘坐：'+' '+info.sharFlightNo+'</br>请按实际乘坐航班办理值机。'})"
        > {{ $t('C132', '共享') }}</span>
        <span
          class="main-color"
          v-show="info.shareFlightNo"
          @click="$dialog.alert({message:'实际乘坐：'+' '+info.shareFlightNo+'</br>请按实际乘坐航班办理值机。'})"
        > {{ $t('C132', '共享') }}</span>
      </div>

      <div
        v-show="showRule"
        class="line-height-normal pad-t-5 font12 text-center main-color  van-hairline--top"
        @click="rule(info)"
      >
        {{ $t('F010', '退改签规则') }}
      </div>
    </van-cell>
    <!--  -->
    <slot name="bottom" />
    <refund-change-rule
      ref="rule"
      :obj="changeRule"
      :cplx="cplx"
    />
  </div>
</template>

<script>
import refundChangeRule from 'Components/refundChangeRule'
import {formatDate} from 'Utils/dateUtil.js'
import {Checkbox, Icon, Tag, Cell, Popup} from 'vant'

export default {
  name: 'Voygae',
  props: {
    flights: {//航班信息
      type: [Array, Object],
      required: true,
      default: function () {
        return []
      }
    },
    showRule: {//是否显示退改规则按钮
      type: Boolean,
      default: false
    },
    showCheck: {//退改签选中按钮
      type: Boolean,
      default: false
    },
    showClear: {//删除行程按钮
      type: Boolean,
      default: false
    },
    showCabin: {//显示舱位
      type: Boolean,
      default: false
    },
    travelType: {
      type: [String, Number],
      default: '0'
    },
    roundTrip: {
      type: [String, Number],
      default: '0'
    }
  },
  components: {
    refundChangeRule,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Cell.name]: Cell,
    [Popup.name]: Popup,
  },
  data() {
    return {
      changeRule: {},
      flight: [],
      cplx: '10901',
      show: false,
      tc: '',
    }
  },
  created() {
    this.init()
    this.xc = this.$route.query.second
    console.log(this.$route.query.second)
  },
  methods: {
    showPopup() {
      this.show = true
    },
    init() {
      this.flight = []
      let arr = this.flights
      let flight = []
      if (Array.isArray(arr)) {
        if (arr.length > 0) {
          let international = 1
          arr.forEach(item => {
            this.tc = item.flightDes
            if (typeof (item.international) === 'undefined') {
            } else {
              international = item.international
            }
            if (item.stopNum > 0) {
              var flightNo = item.flightNo
              if (null != item.sharFlightNo && '' != item.sharFlightNo) {
                flightNo = item.sharFlightNo
              }
              this.$api['tkQuery/queryFlightStop']({
                'date': item.departDate,
                'flightNo': flightNo,
                'departAirport': item.departAirport,
                'arriveAirport': item.arriveAirport
              }).then(res => {
                let cache = res.data || {}
                item.stopOverList = cache.stopList || []
                flight.push(item)
              }).catch(() => {
                item.stopNum = 0
                flight.push(item)
              })
            } else {
              flight.push(item)
            }
          })
          if (international == 1) {
            this.cplx = '10901'
          } else {
            this.cplx = '10902'
          }
          this.flight = flight
          //    this.$nextTick(function () {
          //     // DOM 现在更新了
          //     // `this` 绑定到当前实例
          //     // this.doSomethingElse()
          //     this.flight=JSON.parse(JSON.stringify(flight))
          // })
          //     this.$forceUpdate()
        }
      }
    },
    rule(info) {
      this.changeRule = info
      this.$refs.rule.toggle()
    },
  },
  filters: {
    time(val) {
      if (!val || val.length <= 5) {
        return val
      }
      return formatDate(new Date(val)).hm
    },
    discount(val) {//计算折扣   详情与列表有区别  详情0.  列表1. rubbish
      if (!val) return
      if (val < 1) {
        return (val * 10).toFixed(1) + '折'
      } else if (val == 1) {
        return '全价'
      } else if (val > 1) {
        val = Math.floor(val) / 10
        return val + '倍'
      } else {
        return 0
      }
    }
  },
  watch: {
    'flights.length'() {
      this.init()
    },
  }
}
</script>

<style lang="less" scoped>
@import './business';

.row {
  height: 30px;
}

.title {
  font-size: @font-size-12;
}

.pad-t-5 {
  padding-top: 5px;
}

.stopList {
  display: inline-block;
  padding: 2px 10px 2px 2px;
  border-radius: 10px;
}

.stop {
  display: inline-block;
  padding: 0 4px;
  border-radius: 8px;
  background-color: @color-background-white;
  font-size: @font-size-10;
}

.line {
  display: inline-block;
  position: absolute;
  top: 20px;
  bottom: 20px;
  width: 6px;
  border-right: 1px solid #cccccc;
  height: calc(100% - 40px);
}

.line-bottom, .line-top {
  position: absolute;
  font-size: @font-size-10;
  color: #cccccc;
  background-color: @color-background-white;
}

.line-top {
  top: 10px;
}

.line-bottom {
  bottom: 10px;
}

.tc {
  width: 100%;

  .nr {
    font-size: 15px;
    color: #000;
    font-weight: 600;
    /* margin: 10px; */
    padding: 0.2rem;
    text-align: center;
  }

  .ts {
    display: flex;
    padding: 0.1rem;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>
